/**
 * StatsCards - Stats cards for LiveDashboardV2
 * Shows Total Students, Valid IP Addresses, and Flagged IP count
 * Design matches Labs main page - label/count on left, icon on right
 */
import React from 'react'
import { BsPeopleFill, BsShieldCheck, BsExclamationTriangle } from 'react-icons/bs'
import styles from '../../LabsV2.module.css'

const StatCard = ({ label, value, icon: Icon, iconColorClass, children }) => (
  <div className={styles.statCard}>
    <div className={styles.statCardContent}>
      <span className={styles.statCardLabel}>{label}</span>
      {children || <span className={styles.statCardValue}>{value}</span>}
    </div>
    <div className={`${styles.statCardIcon} ${styles[iconColorClass]}`}>
      <Icon size={24} />
    </div>
  </div>
)

const StatsCards = ({
  totalStudents,
  ipRanges,
  unapprovedCount
}) => {
  // Parse IP ranges from comma-separated string
  const ipRangesList = ipRanges
    ? ipRanges.split(',').filter(ip => ip.trim() !== '')
    : []

  return (
    <div className={styles.statsRow}>
      {/* Total Students Card */}
      <StatCard
        label="Total Students"
        value={totalStudents}
        icon={BsPeopleFill}
        iconColorClass="statCardIconBlue"
      />

      {/* Valid IP Addresses Card */}
      <StatCard
        label="Valid IP Addresses"
        icon={BsShieldCheck}
        iconColorClass="statCardIconGreen"
      >
        <div className={styles.statsCardIpList}>
          {ipRangesList.length > 0 ? (
            ipRangesList.map((ip, index) => (
              <span key={index} className={styles.statsCardIpBadge}>
                {ip.trim()}
              </span>
            ))
          ) : (
            <span className={styles.statsCardIpBadge}>All IPs</span>
          )}
        </div>
      </StatCard>

      {/* Flagged IP Card */}
      <StatCard
        label="Flagged IPs"
        value={unapprovedCount}
        icon={BsExclamationTriangle}
        iconColorClass="statCardIconOrange"
      />
    </div>
  )
}

export default StatsCards
